import {fetchJson} from "../utils/SuperAgentFetch";
import {config} from "../config/Config";


/**
 * 
 * @param {String} entryId 
 * @param {Function<Array[Object]>} callback 
 */
export const fetchWatchCount = (entryId, callback) => {
    let r = fetchJson(`${config.url.API_URL}/entryWatch/custom/entry/${entryId}/items/count`);
    r.then(json => {
        if(json.content) {
            callback(json.content);
        } else {
            callback(null);
        }
    });
};